import React from 'react'
import './DanceStyles.css'

const danceStyles = [
  'Jazz',
  'Ballet',
  'Contemporary',
  'Musical Theatre',
  'Hip Hop',
  'Tap',
  'Acro Dance',
  'Cheerleading',
  'Troupe',
  'Technique',
  'Lil Groovers',
  // 'Private Lessons'
]

const DanceStyles = ({ allowWrap = false }) => {
  return (
    <div className='dance-styles-container'>
      <ul className='dance-styles-list'>
        {danceStyles.map((style, index) => (
          <li key={index} className='dance-style-item'>
            {style}
            {index < danceStyles.length - 1 && <span className='dance-style-separator'>•</span>}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default DanceStyles

